<template>
  <div class="apparea">
    <!----- header area start ----->
    <header class="header-area" v-if="isDesktopApp">
      <div class="container">
        <div class="d-flex justify-content-center">
          <figure class="logo bonauf-app-logo" @click="gotoHome"><img :src="`${speedSizeDomain}/assets/img/app/logo.png`" alt="#" title="" /></figure>
          <button class="btn-close pr-2"  @click="gotoProductPage">
            <i class="fa-solid fa-chevron-right ml-5"></i>
          </button>
        </div>
      </div>
    </header>
    <!----- header area stop ----->
    <div class="body_warrper">
      <section class="kremlin-area kremlin-area2" :style="perspectiveBackground">
        <div class="container">
          <mobile-header-app :product="product" />
          <mobile-head-banner-app :stage="bookingStage" />
          <h2>פרטי הטיסה</h2>
        </div>
      </section>
      <!------ plaindetails area start ------->
      <section class="plaindetails-area">
        <div class="container">
          <flight-item-app :flight="activeFlight" :baggagePriceInfo="baggagePriceInfo" :categoryName="categoryCode" type="booking" />
          <ticket-information v-if="category.code === 'sport_pack'" />
          <div class="bnf-section-heading">
            <span class="bnf-section-icon"><i class="fas fa-users" aria-hidden="true"></i></span>
            <h3 class="bnf-section-title">{{ $t('booking.guest-desc') }}</h3>
            <p class="bnf-section-subtitle">השלם את פרטי כל נוסע באנגלית כפי שמופיע בדרכון</p>
          </div>
        </div>
      </section>
    </div>

    <section ref="passenger" class="plainform-area">
      <div class="container">
        <user-list-room-app v-for="(room, idx) in rooms" :key="idx" :room="room" :index="idx" :destCode="destCode"
          @updatedUser="updatingUser"
        />
        <div class="bnf-section-heading">
          <span class="bnf-section-icon bnf-section-icon-baggage"><i class="fas fa-suitcase" aria-hidden="true"></i></span>
          <h3 class="bnf-section-title">{{ $t('booking.baggage') }}</h3>
          <p class="bnf-section-subtitle">פרט מה כלול ומה תרצה להוסיף לכל נוסע</p>
        </div>
      </div>
    </section>

    <section class="plainform-area">
      <div class="container">
        <baggage-list-app :userList="baggageUserList" :priceInfo="baggagePriceInfo" @updateBaggagePrice="updatingBaggagePrice"/>
        <div class="bnf-section-heading bnf-section-heading-spaced">
          <span class="bnf-section-icon bnf-section-icon-payer"><i class="fas fa-credit-card" aria-hidden="true"></i></span>
          <h3 class="bnf-section-title">{{ $t('booking.payer-details') }}</h3>
          <p class="bnf-section-subtitle">המשלם הוא בעל הכרטיס שיחויב</p>
        </div>
      </div>
    </section>

    <section ref="payer" class="plainform-area2">
      <payer-information-app @updatePayer="updatingPayer" v-if="!bypassPaymentState" />
    </section>

    <div class="container">
      <div class="new_booking_main_area dVacation-pack booking_mobile_part mt-3">
        <div class="booking_details_three">
          <div ref="checkTerms" class="new_booking_main_area dVacation-pack booking_mobile_part mt-md-5">
            <div class="booking_details_three bottom">
              <div class="price_details">
                <div class="price_details_main_body">
                  <div class="price_details_body row">
                    <div class="terms_box">
                      <div class="form-check" v-if="!isOdysseySite">
                        <label :class="['form-check-label', 'pr-5', !checkedTerms ? 'danger' : '']">
                          <input type="checkbox" class="form-check-input" v-model="checkedTerms" />
                          {{ $t('booking.i-agree-to') }}
                          <strong @click="() => showLinkInfo(`/%D7%AA%D7%A7%D7%A0%D7%95%D7%9F_%D7%91%D7%99%D7%98%D7%95%D7%9C_%D7%95%D7%96%D7%99%D7%9B%D7%95%D7%99`)">{{ $t('booking.agree-desc') }}
                          </strong>
                          {{ $t('booking.read-desc') }}
                        </label>
                        <label :class="['form-check-label', 'pr-5', 'mt-2', !checkedTermsForDXB ? 'danger' : '']" v-if="isDxbDest">
                          <span>
                            <input type="checkbox" class="form-check-input" v-model="checkedTermsForDXB" />
                          </span>
                          {{ $t('booking.confirmed-read') }}
                          <strong class="pointer" @click="() => showLinkInfo(`/%D7%94%D7%A0%D7%97%D7%99%D7%95%D7%AA_%D7%9C%D7%98%D7%A1%D7%99%D7%9D_%D7%9C%D7%93%D7%95%D7%91%D7%90%D7%99`)">
                            {{ $t('booking.dxb-terms') }}
                          </strong>
                        </label>
                      </div>
                      <div class="form-check" v-if="cancellationAllowed">
                        <label class="form-check-label pr-5">
                          <input
                            type="checkbox"
                            class="form-check-input"
                            v-model="checkedCancellation"
                            :disabled="!cancellationAllowed"
                          />
                          {{ $t('booking.cancellation-agree') }} <strong @click="showLinkInfo('/תקנון_פליינג_סייף_(Flying_Safe)')">{{ $t('booking.flying-safe') }}</strong>
                        </label>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <!----- trust signals strip ----->
              <div class="trust-signals" aria-hidden="false">
                <span class="trust-item"><i class="fas fa-lock"></i> תשלום מאובטח SSL</span>
                <span class="trust-item"><i class="fas fa-shield-alt"></i> פרטיות מוגנת</span>
                <span class="trust-item"><i class="fas fa-headset"></i> תמיכה טלפונית</span>
              </div>
              <!----- order area start ----->
              <section class="order-area total_payment bnf-totals-panel">
                <div class="container">
                  <div class="order-list bnf-totals-list">
                    <button type="button" class="bnf-totals-info" @click="showNotice()" aria-label="פרטים נוספים על המחיר">
                      <i class="fas fa-info-circle" aria-hidden="true"></i>
                    </button>
                    <ul>
                      <li class="bnf-totals-row bnf-totals-primary">
                        <span class="bnf-totals-label">סה״כ לתשלום בשקלים</span>
                        <strong class="bnf-totals-value">{{ totalPriceShekels }}</strong>
                      </li>
                      <li class="bnf-totals-row bnf-totals-secondary">
                        <span class="bnf-totals-label">{{ $t('booking.total-payment') }}</span>
                        <strong class="bnf-totals-value">{{ totalPriceRegular }}</strong>
                      </li>
                      <li class="bnf-totals-breakdown" v-if="hasInfantsBooking">
                        <i class="fas fa-info-circle" aria-hidden="true"></i>
                        {{ getPriceWithSymbol(product.cc, packageBaseTotalBooking) }} (חבילה) + {{ getPriceWithSymbol(product.cc, totalInfantCost) }} ({{ totalInfantsCount === 1 ? 'תינוק' : `${totalInfantsCount} תינוקות` }})
                      </li>
                    </ul>
                  </div>
                  <div class="btn-box bnf-cta-wrap">
                    <button class="btn-primary bnf-cta-primary" @click="BookingNow" :disabled="disableBook">
                      <span v-if="disableBook" class="cta-loading">
                        <b-spinner small type="grow"></b-spinner>
                        מעבד...
                      </span>
                      <span v-else class="bnf-cta-text-wrap">
                        <span class="bnf-cta-text">{{ $t('search-result.book-now') }}</span>
                        <i class="fas fa-arrow-left bnf-cta-arrow" aria-hidden="true"></i>
                      </span>
                    </button>
                  </div>
                </div>
              </section>
              <!----- order area stop ----->
            </div>
          </div>

        </div>
      </div>
    </div>
    <!----- sticky bottom bar (mobile only) ----->
    <div class="sticky-cta-bar" v-if="!isDesktopApp">
      <div class="sticky-cta-price">
        <span class="sticky-cta-label">סה"כ לתשלום</span>
        <strong class="sticky-cta-amount">{{ totalPriceShekels }}</strong>
      </div>
      <button class="sticky-cta-btn" @click="BookingNow" :disabled="disableBook">
        <span v-if="disableBook">
          <b-spinner small type="grow"></b-spinner>
        </span>
        <span v-else>
          {{ $t('search-result.book-now') }}
        </span>
      </button>
    </div>
    <!----- sticky bottom bar stop ----->
    <b-modal id="countDownModal" centered size="lg" :dir="lang == 'he' ? 'rtl' : 'ltr'" :no-close-on-backdrop="true"
      :ok-only="true">
      <template #modal-header>
        <div class="d-flex flex-grow-1 align-items-baseline" :class="[lang == 'he' ? 'text-right' : 'text-left']">
          <h3 class="m-auto">{{ $t('booking.notice') }}</h3>
          <h5>{{ maxSec }} {{ $t('booking.sec') }}</h5>
        </div>
      </template>
      <template>
        <span :class="[lang == 'he' ? 'text-right' : 'text-left']">{{
          $t('booking.go-product-page')
        }}</span>
      </template>
      <template #modal-footer="{ ok }">
        <b-button size="lg" variant="success" @click="
          gotoProductPage();
        ok();
        ">
          {{ $t('booking.ok') }}
        </b-button>
      </template>
    </b-modal>
    <b-modal id="actionModal" centered size="lg" :dir="lang == 'he' ? 'rtl' : 'ltr'" :no-close-on-backdrop="true"
      :ok-only="true" :hide-footer="true">
      <template #modal-header>
        <div class="d-flex flex-grow-1 align-items-baseline" :class="[lang == 'he' ? 'text-right' : 'text-left']">
          <h3 class="m-auto">{{ $t('booking.notice') }}</h3>
        </div>
      </template>
      <template>
        <h5 :class="[lang == 'he' ? 'text-right' : 'text-left']">{{ $t('booking.modal-delaying') }}</h5>
        <div class="actionContainer justify-content-between">
          <div class="col-sm-4 col-12">
            <div class="text-center">
              <b-link @click.prevent="delayAction('ToContinue')"><img :src="`${speedSizeDomain}/assets/img/next.jpg`"
                  class="col-6 icon_box" width="50" height="50" alt="next" />
                <h6 class="m-auto">{{ $t('booking.modal-continue') }}</h6>
              </b-link>
            </div>
          </div>
          <div class="col-sm-4 col-12">
            <div class="text-center">
              <b-link @click.prevent="delayAction('ToCall')"><img :src="`${speedSizeDomain}/assets/img/phoneCall.png`"
                  class="col-6 icon_box " width="50" height="50" alt="phone-call" />
                <h6 class="m-auto">{{ $t('booking.modal-call', { phoneNumber: phoneNumber }) }}</h6>
              </b-link>
            </div>
          </div>
          <div class="col-sm-4 col-12">
            <div class="text-center">
              <b-link @click.prevent="delayAction('ToBack')"><img :src="`${speedSizeDomain}/assets/img/previous.jpg`"
                  class="col-6 icon_box " width="50" height="50" alt="previous" />
                <h6 class="m-auto">{{ $t('booking.modal-back') }}</h6>
              </b-link>
            </div>
          </div>
        </div>
      </template>
    </b-modal>
    <b-modal id="actionRetryDebit" centered size="xl" :dir="lang == 'he' ? 'rtl' : 'ltr'" :no-close-on-backdrop="true"
      :ok-only="true" :hide-footer="true">
      <template #modal-header>
        <div class="d-flex flex-grow-1 align-items-baseline" :class="[lang == 'he' ? 'text-right' : 'text-left']">
          <h3 class="m-auto">{{ $t('booking.notice-retry') }}</h3>
        </div>
      </template>
      <template>
        <payer-information @updatePayer="updatingPayer" v-if="!bypassPaymentState" />
        <div :class="['action_buttons d-flex m-3', lang == 'he' ? 'float-left' : 'float-right']">
          <b-button class="m-3" block @click="retryBookWithNewPayerInfo"
            variant="outline-success">{{ $t("booking.retry-booking") }}</b-button>
          <!-- <b-button class="m-3" block @click="$bvModal.hide('actionRetryDebit')" variant="outline-success">{{$t("booking.close")}}</b-button> -->
        </div>
      </template>
    </b-modal>
    <b-modal id="extraLinkInfo" centered size="xl" :dir="lang == 'he' ? 'rtl' : 'ltr'" :ok-only="true"
      :hide-footer="true">
      <template>
        <iframe id="linkInformation" title="Extra Inforamtion" :src="linkInfo">
        </iframe>
      </template>
    </b-modal>
  </div>
</template>

<script>
import { BModal, BButton, BLink, BSpinner } from 'bootstrap-vue';
import TemplateHotelFlightApp from './TemplateHotelFlightApp';

export default {
  components: {
    BButton,
    BModal,
    BLink,
    BSpinner,
    MobileHeaderApp: () => import('@/components/booking/atoms/MobileHeaderApp'),
    MobileHeadBannerApp: () => import('@/components/booking/atoms/MobileHeadBannerApp'),
    FlightItemApp: () => import('@/components/atoms/FlightItemApp'),
    TicketInformation: () => import('@/components/booking/atoms/TicketInformation'),
    UserListRoomApp: () => import('@/components/booking/atoms/UserListRoomApp'),
    BaggageListApp: () => import('@/components/booking/atoms/BaggageListApp'),
    PayerInformationApp: () => import('@/components/booking/atoms/PayerInformationApp'),
  },
  extends: TemplateHotelFlightApp,
};
</script>

<style scoped>
/* ===== Trust signals strip (above CTA) ===== */
.trust-signals {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 12px;
  padding: 8px 12px;
  margin: 12px auto 4px;
  background: #f7faff;
  border: 1px solid #e1e9f5;
  border-radius: 8px;
  font-size: 13px;
  color: #2d4a6b;
  max-width: 600px;
}
.trust-signals .trust-item {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  white-space: nowrap;
}
.trust-signals .trust-item i {
  color: #28a745;
  font-size: 12px;
}

/* ===== Loading state inside CTA button ===== */
.cta-loading {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  justify-content: center;
}

/* ===== Sticky bottom CTA bar (mobile only) ===== */
.sticky-cta-bar {
  display: none;
}

@media (max-width: 768px) {
  .sticky-cta-bar {
    display: flex;
    align-items: center;
    justify-content: space-between;
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 1030;
    padding: 8px 12px;
    background: #ffffff;
    border-top: 1px solid #e1e9f5;
    box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.08);
    direction: rtl;
  }
  .sticky-cta-price {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    line-height: 1.1;
    flex: 0 0 auto;
  }
  .sticky-cta-label {
    font-size: 11px;
    color: #6c757d;
  }
  .sticky-cta-amount {
    font-size: 18px;
    font-weight: 700;
    color: #000;
  }
  .sticky-cta-btn {
    flex: 1 1 auto;
    margin-right: 12px;
    padding: 12px 16px;
    background: linear-gradient(135deg, #0061ab 0%, #1c7ed6 100%);
    background-image: linear-gradient(135deg, #0061ab 0%, #1c7ed6 100%);
    color: #fff;
    border: 0;
    border-radius: 10px;
    font-size: 16px;
    font-weight: 700;
    min-height: 48px;
    box-shadow: 0 3px 10px rgba(0, 97, 171, 0.32);
    cursor: pointer;
    transition: filter 0.18s ease, box-shadow 0.18s ease, transform 0.1s ease;
  }
  .sticky-cta-btn:disabled {
    background: linear-gradient(135deg, #94a8c5 0%, #b6c6dd 100%);
    background-image: linear-gradient(135deg, #94a8c5 0%, #b6c6dd 100%);
    cursor: not-allowed;
    box-shadow: none;
  }
  .sticky-cta-btn:hover:not(:disabled) {
    filter: brightness(1.06);
    box-shadow: 0 5px 14px rgba(0, 97, 171, 0.4);
  }
  .sticky-cta-btn:active:not(:disabled) {
    transform: translateY(1px);
    box-shadow: 0 2px 6px rgba(0, 97, 171, 0.28);
  }

  /* Push body content above sticky bar so it's not hidden */
  .apparea {
    padding-bottom: 72px;
  }
}

@media (max-width: 479px) {
  .trust-signals {
    font-size: 12px;
    gap: 8px;
    padding: 6px 8px;
    margin: 8px 8px 4px;
  }
  .trust-signals .trust-item {
    font-size: 11px;
  }
}

/* ===== Round 4: totals panel restyle ===== */
.bnf-totals-panel {
  margin: 16px auto;
  padding: 0;
  background: transparent !important;
}
.bnf-totals-panel .container {
  max-width: 720px;
  margin: 0 auto;
  background: linear-gradient(180deg, #ffffff 0%, #f7faff 100%);
  border: 1px solid #d8e3f0;
  border-radius: 14px;
  padding: 18px 16px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.05);
  position: relative;
}
.bnf-totals-list {
  position: relative;
  margin-bottom: 14px;
}
.bnf-totals-info {
  position: absolute;
  top: -2px;
  left: 0;
  width: 36px;
  height: 36px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #eef6ff 0%, #d6e9ff 100%);
  color: #1c7ed6;
  border: 1.5px solid #cfe2ff;
  border-radius: 50%;
  cursor: pointer;
  transition: all 0.2s ease;
  box-shadow: 0 2px 6px rgba(28, 126, 214, 0.15);
  padding: 0;
}
.bnf-totals-info:hover,
.bnf-totals-info:focus {
  background: linear-gradient(135deg, #1c7ed6 0%, #0061ab 100%);
  color: #ffffff;
  outline: none;
  transform: scale(1.08);
  box-shadow: 0 3px 10px rgba(28, 126, 214, 0.35);
  border-color: #1c7ed6;
}
.bnf-totals-info i {
  font-size: 16px;
  background: transparent !important;
  border: 0 !important;
  width: auto !important;
  height: auto !important;
}
.bnf-totals-list ul {
  list-style: none;
  margin: 0;
  padding: 0 36px 0 0;
}
.bnf-totals-row {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: 12px;
  margin: 0;
  padding: 4px 0;
  line-height: 1.2;
}
.bnf-totals-row .bnf-totals-label {
  font-size: 13px;
  color: #475569;
  font-weight: 500;
}
.bnf-totals-row .bnf-totals-value {
  font-weight: 700;
  color: #0e436b;
}
.bnf-totals-primary .bnf-totals-label {
  font-size: 14px;
  color: #1c4e80;
  font-weight: 600;
}
.bnf-totals-primary .bnf-totals-value {
  font-size: 28px;
  color: #0e436b;
}
.bnf-totals-secondary .bnf-totals-label {
  font-size: 12px;
}
.bnf-totals-secondary .bnf-totals-value {
  font-size: 16px;
  color: #475569;
}
/* Breakdown line — small chip below totals when there are infants */
.bnf-totals-breakdown {
  list-style: none;
  margin: 6px 0 0 !important;
  padding: 4px 12px !important;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  background: #eef6ff;
  border: 1px solid #cfe2ff;
  border-radius: 999px;
  font-size: 11.5px;
  font-weight: 500;
  color: #1c4e80;
  width: fit-content;
  align-self: flex-end;
  line-height: 1.3;
}
.bnf-totals-breakdown i {
  font-size: 11px;
  color: #1c7ed6;
}

/* ===== Round 4: primary CTA on booking page ===== */
.bnf-cta-wrap {
  width: 100%;
  display: block;
}
.bnf-cta-primary.btn-primary {
  display: inline-flex !important;
  align-items: center;
  justify-content: center;
  width: 100%;
  padding: 14px 24px;
  background: linear-gradient(135deg, #0061ab 0%, #1c7ed6 100%) !important;
  background-image: linear-gradient(135deg, #0061ab 0%, #1c7ed6 100%) !important;
  color: #ffffff !important;
  border: none !important;
  border-radius: 12px;
  font-size: 17px;
  font-weight: 700;
  letter-spacing: 0.3px;
  min-height: 54px;
  box-shadow: 0 4px 14px rgba(0, 97, 171, 0.32);
  transition: transform 0.12s ease, box-shadow 0.18s ease, filter 0.18s ease;
  cursor: pointer;
}
.bnf-cta-primary.btn-primary:hover:not(:disabled),
.bnf-cta-primary.btn-primary:focus:not(:disabled) {
  box-shadow: 0 6px 20px rgba(0, 97, 171, 0.42);
  filter: brightness(1.05);
  outline: none;
}
.bnf-cta-primary.btn-primary:active:not(:disabled) {
  transform: translateY(1px);
  box-shadow: 0 2px 8px rgba(0, 97, 171, 0.28);
}
.bnf-cta-primary.btn-primary:disabled {
  background: linear-gradient(135deg, #94a8c5 0%, #b6c6dd 100%) !important;
  background-image: linear-gradient(135deg, #94a8c5 0%, #b6c6dd 100%) !important;
  cursor: not-allowed;
  box-shadow: none;
  opacity: 1;
}
.bnf-cta-text-wrap {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  justify-content: center;
}
.bnf-cta-text-wrap .bnf-cta-arrow {
  font-size: 14px;
  transition: transform 0.2s ease;
}
.bnf-cta-primary.btn-primary:hover .bnf-cta-arrow {
  transform: translateX(-3px);
}

@media (max-width: 479px) {
  .bnf-totals-panel .container {
    padding: 14px 12px;
  }
  .bnf-totals-primary .bnf-totals-value {
    font-size: 24px;
  }
  .bnf-totals-secondary .bnf-totals-value {
    font-size: 14px;
  }
  .bnf-cta-primary.btn-primary {
    font-size: 16px;
    min-height: 50px;
    padding: 12px 20px;
  }
}
</style>
